import React from 'react';
import Image from 'next/image';
import styles from './Announcements.module.css';

const Announcements = () => {
    const announcements = [
        {
            id: 1,
            title: "Awarded with our first 765 kV project",
            date: "09 September 2024"
        },
        {
            id: 2,
            title: "We are hiring project delivery people",
            date: "09 September 2024"
        },
        {
            id: 3,
            title: "PISCESIA delivering a project in the Ladakh region",
            date: "09 September 2024"
        }
    ];

    const customers = [
        {
            id: 1,
            name: "Indian Railways",
            logoImage: "/logos/client_logo/indian-railway.jpg"
        },
        {
            id: 2,
            name: "UPRNNL",
            logoImage: "/logos/client_logo/uprnnl.avif"
        },
        {
            id: 3,
            name: "UPPTCL",
            logoImage: "/logos/client_logo/upptcl.png"
        },
        {
            id: 4,
            name: "Purwanchal Vidyut",
            logoImage: "/logos/client_logo/purwanchal.jpeg"
        },
        {
            id: 5,
            name: "Noida Authority",
            logoImage: "/logos/client_logo/noida-auth.jpeg"
        },
        {
            id: 6,
            name: "Madhyanchal Vidyut",
            logoImage: "/logos/client_logo/madhyanchal.png"
        },
        {
            id: 7,
            name: "Lucknow Development Vidyut",
            logoImage: "/logos/client_logo/lucknow-develop.jpeg"
        },
        
        
    ];

    return (
        <div className={styles.announcementsWrapper}>
            {/* Announcements Section */}
            {/* <section className={styles.announcementsSection}>
                <div className={styles.container}>
                   
                    
                    <div className={styles.announcementsContainer}>
                        <div className={styles.announcementsGrid}>
                            {announcements.map((announcement) => (
                                <div key={announcement.id} className={styles.announcementCard}>
                                    <div className={styles.cardContent}>
                                        <h3 className={styles.cardTitle}>{announcement.title}</h3>
                                        <div className={styles.cardDate}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className={styles.dateIcon}>
                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                                                <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"/>
                                                <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"/>
                                                <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                                            </svg>
                                            <span>{announcement.date}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className={styles.blueRibbon}></div>
                    </div>
                </div>
            </section> */}

            {/* Customers Section - Scrolling Ribbon */}
            <section className={styles.customersSection} aria-labelledby="customers-title">
                <div className={styles.container}>
                   <h2 className={styles.announcementsTitle}>Our <span className={styles.bluelabel}>Clients</span></h2>
                    
                    <div 
                        className={styles.scrollingRibbon}
                        role="region"
                        aria-label="Our customers logos continuously scrolling from right to left"
                    >
                        <div className={styles.logoTrack}>
                            {/* First set of logos */}
                            {customers.map((customer) => (
                                <div key={customer.id} className={styles.customerLogo}>
                                    <div className={styles.logoImageContainer}>
                                        <Image
                                            src={customer.logoImage}
                                            alt={customer.name}
                                            width={400}
                                            height={200}
                                            className={styles.logoImage}
                                        />
                                    </div>
                                </div>
                            ))}
                            {/* Duplicate set for seamless loop */}
                            {customers.map((customer) => (
                                <div key={`${customer.id}-duplicate`} className={styles.customerLogo}>
                                    <div className={styles.logoImageContainer}>
                                        <Image
                                            src={customer.logoImage}
                                            alt={customer.name}
                                            width={400}
                                            height={200}
                                            className={styles.logoImage}
                                        />
                                    </div>
                                </div>
                            ))}
                            {/* Triple set for extra smooth scrolling */}
                            {customers.map((customer) => (
                                <div key={`${customer.id}-triple`} className={styles.customerLogo}>
                                    <div className={styles.logoImageContainer}>
                                        <Image
                                            src={customer.logoImage}
                                            alt={customer.name}
                                            width={400}
                                            height={200}
                                            className={styles.logoImage}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Announcements;
